import { ElementType, forwardRef } from "react";
import { Radio, RadioGroup, RadioGroupProps } from "@headlessui/react";

import { ErrorText } from "./typography/ErrorText";

export interface RadioGroupOption {
  value: string;
  label: string;
}

interface RadioRatingProps
  extends Partial<RadioGroupProps<ElementType<HTMLDivElement>, string>> {
  options: RadioGroupOption[];
  lowerRateLevel?: string;
  highestRateLevel?: string;
  error?: string;
}

export const RadioRating = forwardRef<HTMLDivElement, RadioRatingProps>(
  ({ options, lowerRateLevel, highestRateLevel, error, ...props }, ref) => (
    <div className="flex w-full flex-col gap-1">
      <RadioGroup
        as="div"
        ref={ref}
        {...props}
        className="relative flex w-full justify-between"
      >
        <div className="absolute bottom-2 left-0 right-0 h-0.5 bg-gray-300" />
        {options.map((option) => (
          <Radio key={option.value} value={option.value} className="relative">
            {({ checked, disabled }) => (
              <div className="flex cursor-pointer flex-col items-center gap-1">
                <p>{option.label}</p>
                <input
                  readOnly
                  checked={checked}
                  disabled={disabled}
                  type="radio"
                  className="size-5 border-2 border-neutral-700 bg-neutral-25 text-primary-500 focus:ring-1 focus:ring-primary-500 disabled:text-gray-300"
                />
              </div>
            )}
          </Radio>
        ))}
      </RadioGroup>
      <div className="flex justify-between">
        <p className="text-sm italic text-gray-5">{lowerRateLevel}</p>
        <p className="text-sm italic text-gray-5">{highestRateLevel}</p>
      </div>
      {error && <ErrorText>{error}</ErrorText>}
    </div>
  ),
);

RadioRating.displayName = "RadioRating";
